import type { IBlockResult, INotionBlock } from '~/types/notion'

import config from '~/config'
import { request } from '~/utils/request'

export const getBlockChildren = (pageId: string): Promise<INotionBlock> => {
  return request({
    url: `${config.SERVICES_API}/notion/blocks/${pageId}/children`,
  })
}

export const getNotionPage = async (pageId: string): Promise<INotionBlock> => {
  const getChildren = (results: IBlockResult[]): Promise<IBlockResult>[] => {
    return results.map(async (block) => {
      if ('has_children' in block && block.has_children) {
        const children = await getBlockChildren(block.id)
        return { ...block, children: await Promise.all(getChildren(children.results)) }
      } else {
        return block
      }
    })
  }

  const response = await getBlockChildren(pageId)

  const children = await Promise.all(getChildren(response.results))

  return { ...response, results: children }
}
